import React, { useState, createRef, useEffect } from "react";
import { useLocation } from "@reach/router";
import { useSubstrate } from "./substrate-lib";
import { Button, Col, Row, Table } from "antd";
import "antd/dist/antd.css";
import { ToastProvider, useToasts } from "react-toast-notifications";
import { parse } from "query-string";
import { ArrowDownOutlined } from "@ant-design/icons";
import { fetchAPI } from "./utils/fetchUtil";
import backgroundImageOne from "./assets/images/Continuum3-min.png";
import SocialLinks from "./SocialLinks";

export default function CheckWhitelist(props) {
  const [walletAddress, setWalletAddress] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const updateWalletAddress = (e) => {
    setWalletAddress(e.target.value);
  };

  const checkPrewhitelistWallet = async () => {
    setIsLoading(true);
    fetchAPI(`/check-whitelisting/${address}`)
      .then((response) => {
        if (response.isValid) {
          Swal.fire(
            `Your submitted detail for wallet address ${walletAddress}:`,
            `Email address: ${response.emailAddress}`,
            "success"
          );
          setIsLoading(false);
        }
      })
      .catch((err) => {});
  };

  return (
    <ToastProvider autoDismiss>
      <div className="title-header">
        <h2>Check your pre-whitelist submission detail</h2>
      </div>
      <Row>
        <Col span={24} style={{ margin: "auto" }}>
          <div className="amount-container">
            <div className="chain-out">
              <Col span={24}>
                <label>Your Wallet Address</label>
                <div className="amount-input">
                  <input
                    type="text"
                    id="address"
                    name="address"
                    className="input-field"
                    onBlur={(e) => updateWalletAddress(e)}
                    onCopy={(e) => e.preventDefault()}
                    onKeyDown={(e) => {
                      if (e.key == "Enter") {
                        updateWalletAddress(e);
                      }
                    }}
                    autoFocus
                  />
                </div>
              </Col>
            </div>
          </div>
        </Col>
        <Col span={24} style={{ margin: "auto" }}>
          <div className="button-section" style={{ textAlign: "center" }}>
            <Button
              className="primary-button"
              type="primary"
              title="Next"
              style={{
                maxWidth: "100%",
                marginBottom: "2rem",
                zIndex: "1",
              }}
              onClick={() => checkPrewhitelistWallet()}
              loading={isLoading}
            >
              Check Pre-whitelist detail
            </Button>
          </div>
        </Col>
      </Row>
    </ToastProvider>
  );
}

export function JoinNewLetterButton(props) {
  const { addToast } = useToasts();

  return (
    <Button
      className="primary-button"
      type="primary"
      onClick={() => {
        addToast(
          "We just sent you the confirmation email, please click the confirmation email to verify",
          { appearance: "success" }
        );
      }}
    >
      Join
    </Button>
  );
}
